import { Plugin } from '@nuxt/types'

const initPlugin: Plugin = async ({ store, route, redirect }) => {
  await store.dispatch('nuxtClientInit', { route, redirect })
}

export default initPlugin
